import React from 'react';
import { portfolioData } from '../../data/portfolioData';
import WebGuidesSection from '../WebGuides';

const CyberpunkPortfolio = ({
  activeSection,
  setActiveSection,
  isMenuOpen,
  setIsMenuOpen
}) => {
  const sections = ['bio', /*'projects'*/, 'writing', /*'books'*/];

  const renderContent = () => {
    switch (activeSection) {
      case 'bio':
        return (
          <div className="space-y-6">
            <h1 className="text-4xl font-bol d">{portfolioData.bio.name}</h1>
            <p>{portfolioData.bio.description.part1}</p>
            <p>{portfolioData.bio.description.part2}</p>
            <p>{portfolioData.bio.description.part3}</p>
          </div>
        );

      /*
      case 'projects':
        return (
          <div className="grid gap-6 md:grid-cols-2">
            {portfolioData.projects.map((project, index) => (
              <div key={index} className="border border-green-400/20 p-6 rounded-lg hover:border-green-400/40 transition-colors">
                <h3 className="text-xl font-bold mb-2">{project.title}</h3>
                <p className="text-gray-400 mb-4">{project.description}</p>
                <div className="flex flex-wrap gap-2">
                  {project.tech.map((tech, techIndex) => (
                    <span key={techIndex} className="px-2 py-1 bg-green-500/20 text-green-500 rounded text-sm">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        );

      case 'books':
        return (
          <div className="grid gap-4">
            {portfolioData.books.map((item, index) => (
              <a
                key={index}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="border border-green-400/20 p-4 rounded-lg hover:border-green-400/40 transition-colors flex justify-between items-center"
              >
                <span>{item.title}</span>
                <span className="text-sm text-green-500">{item.type}</span>
              </a>
            ))}
          </div>
        );
        */

        case 'writing':
          return (
            <WebGuidesSection content={portfolioData.writing} />
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-black text-green-400 font-mono">
      {/* Mobile menu button */}
      <button
        className="md:hidden fixed top-4 right-4 z-50 p-2"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <span className="sr-only">Toggle menu</span>
        <div className={`w-6 h-0.5 bg-green-400 transition-all ${isMenuOpen ? 'rotate-45 translate-y-0.5' : ''}`} />
        <div className={`w-6 h-0.5 bg-green-400 mt-1.5 ${isMenuOpen ? 'opacity-0' : ''}`} />
        <div className={`w-6 h-0.5 bg-green-400 mt-1.5 transition-all ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`} />
      </button>

      {/* Navigation */}
      <nav className={`
        fixed top-0 right-0 h-full bg-black w-64 transform transition-transform md:relative md:transform-none md:w-full md:h-auto
        ${isMenuOpen ? 'translate-x-0' : 'translate-x-full md:translate-x-0'}
      `}>
        <div className="flex flex-col md:flex-row md:justify-center gap-4 p-8">
          {sections.map((section) => (
            <button
              key={section}
              onClick={() => {
                setActiveSection(section);
                setIsMenuOpen(false);
              }}
              className={`px-4 py-2 rounded ${
                activeSection === section
                  ? 'bg-green-500 text-black'
                  : 'hover:bg-green-500/20'
              }`}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </button>
          ))}
        </div>
      </nav>

      {/* Main content */}
      <main className="max-w-4xl mx-auto p-8 pt-20 md:pt-8">
        {renderContent()}
      </main>
    </div>
  );
};

export default CyberpunkPortfolio;